import { render, staticRenderFns } from "./playerarea.vue?vue&type=template&id=15a6d9f0&scoped=true"
import script from "./playerarea.vue?vue&type=script&lang=js"
export * from "./playerarea.vue?vue&type=script&lang=js"
import style0 from "./playerarea.vue?vue&type=style&index=0&id=15a6d9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a6d9f0",
  null
  
)

export default component.exports